export function XML_Param5(paramID, param1, param2, param3, param4, param5, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementQuin(paramID, param1, param2, param3, param4, param5, s);
}
